import React, { createContext, useContext } from 'react'

type MobileShellMenuContextValue = {
  openMenu: () => void
}

const MobileShellMenuContext = createContext<MobileShellMenuContextValue | null>(null)

export function MobileShellMenuProvider({
  openMenu,
  children,
}: {
  openMenu: () => void
  children: React.ReactNode
}) {
  return (
    <MobileShellMenuContext.Provider value={{ openMenu }}>{children}</MobileShellMenuContext.Provider>
  )
}

export function useMobileShellMenuOptional() {
  return useContext(MobileShellMenuContext)
}
